export default "__VITE_ASSET__a159944d__"